import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiResponse } from '../../models/api-response.model';
import { DownloadPaymentScheduleCSV } from '../../models/download-payment-schedule-csv.model';
import { Milestone2PaymentBatchDetails } from '../../models/milestone2-payment-batch-details.model';
import { PaymentBatchDetails } from '../../models/payment-batch-details.model';
import { PaymentBatchList } from '../../models/payment-batch-list.model';
import { PaymentBatchMilestone2 } from '../../models/payment-batch-milestone2.model';
import { PaymentBatchStatusM2 } from '../../models/payment-batch-status-m2.model';
import { PaymentBatchStatusDropDown } from '../../models/payment-batch-status.model';
import { PaymentBatch } from '../../models/payment-batch.model';
import { PaymentScheduleActivitiesM2 } from '../../models/payment-schedule-activities-m2.model';
import { PaymentScheduleEngagements } from '../../models/payment-schedule-engagements.model';
import { SettingsService } from '../common/settings.service';

@Injectable({
  providedIn: 'root'
})
export class PaymentScheduleService {
  constructor(
    private http: HttpClient,
    public settings: SettingsService
  ) {}

  getAllPaymentBatch(ua: string): Observable<PaymentBatchList[]> {
    return this.http.get<PaymentBatchList[]>(
      this.settings.baseUrl + 'api/PaymentSchedule/GetAllPaymentBatch/ua/' + ua
    );
  }

  getPaymentScheduleEngagementDetials(
    ua: string,
    programTypeId = null
  ): Observable<PaymentScheduleEngagements[]> {
    if (programTypeId != null) {
      return this.http.get<PaymentScheduleEngagements[]>(
        this.settings.baseEventsUrl +
          'api/CSIPaymentSchedule/GetEngagementsForNewM1PaymentBatch'
      );
    } else {
      return this.http.get<PaymentScheduleEngagements[]>(
        this.settings.baseUrl +
          'api/PaymentSchedule/GetPaymentScheduleEngagementDetials/ua/' +
          ua
      );
    }
  }

  getPaymentBatchEngagement(
    pbName: string,
    ua: string,
    programTypeId = null
  ): Observable<PaymentBatchDetails> {
    if (programTypeId != null) {
      return this.http.get<PaymentBatchDetails>(
        this.settings.baseEventsUrl +
          'api/CSIPaymentSchedule/PaymentBatchDetails/' +
          pbName
      );
    } else {
      return this.http.get<PaymentBatchDetails>(
        this.settings.baseUrl +
          'api/PaymentSchedule/GetAllPaymentBatchEngagement/PaymentBatchName/' +
          pbName +
          '/ua/' +
          ua
      );
    }
  }

  getPaymentBatchStatus(): Observable<PaymentBatchStatusDropDown[]> {
    return this.http.get<PaymentBatchStatusDropDown[]>(
      this.settings.baseUrl + 'api/PaymentSchedule/GetPaymentBatchStatus'
    );
  }

  createPaymentBatch(createpb: PaymentBatch, programTypeId = null) {
    if (programTypeId == null) {
      const headers = new HttpHeaders().set('content-type', 'application/json');
      return this.http.post<ApiResponse>(
        this.settings.baseUrl +
          'api/PaymentSchedule/SubmitOFactPaymentSchedule',
        createpb,
        { headers }
      );
    } else {
      const headers = new HttpHeaders().set('content-type', 'application/json');
      return this.http.post<ApiResponse>(
        this.settings.baseEventsUrl +
          'api/CSIPaymentSchedule/CreateM1PaymentBatch',
        createpb,
        { headers }
      );
    }
  }

  updatePaymentBatch(editpb: PaymentBatch, programTypeId = null) {
    if (programTypeId == null) {
      const headers = new HttpHeaders().set('content-type', 'application/json');
      return this.http.post<ApiResponse>(
        this.settings.baseUrl + 'api/PaymentSchedule/EditOFactPaymentSchedule',
        editpb,
        { headers }
      );
    } else {
      const headers = new HttpHeaders().set('content-type', 'application/json');
      return this.http.post<ApiResponse>(
        this.settings.baseEventsUrl +
          'api/CSIPaymentSchedule/UpdateM1PaymentBatch',
        editpb,
        { headers }
      );
    }
  }
  getDownloadCSVFile(): Observable<DownloadPaymentScheduleCSV[]> {
    return this.http.get<DownloadPaymentScheduleCSV[]>(
      this.settings.baseUrl +
        'api/PaymentSchedule/ListofPaymentScheduleCsvFiles/ADD/'
    );
  }
  getDownloadCSVFileEdit(
    fileName: string
  ): Observable<DownloadPaymentScheduleCSV[]> {
    return this.http.get<DownloadPaymentScheduleCSV[]>(
      this.settings.baseUrl +
        'api/PaymentSchedule/ListofPaymentScheduleCsvFiles/EDIT/' +
        fileName
    );
  }

  downloadExportPoeCSV(selectedID: any[]) {
    const headers = new HttpHeaders();
    return this.http.post(
      this.settings.baseUrl + 'api/PoeInformation/DownloadPOESurveyDocs',
      selectedID,
      { headers, responseType: 'blob' }
    );
  }

  getMilestone2PaymentBatch(): Observable<PaymentBatchList[]> {
    return this.http.get<PaymentBatchList[]>(
      this.settings.baseUrl + 'api/PaymentSchedule/GetAllMilestone2PaymentBatch'
    );
  }

  GetMilestone2PaymentScheduleActivities(): Observable<
    PaymentScheduleActivitiesM2[]
  > {
    return this.http.get<PaymentScheduleActivitiesM2[]>(
      this.settings.baseUrl +
        'api/PaymentSchedule/GetMilestone2PaymentScheduleActivities'
    );
  }

  createPaymentBatchMilestone2(createpb: PaymentBatchMilestone2) {
    const headers = new HttpHeaders().set('content-type', 'application/json');
    return this.http.post<ApiResponse>(
      this.settings.baseUrl +
        'api/PaymentSchedule/SubmitPaymentBatchMilestone2',
      createpb,
      { headers }
    );
  }

  getMilestone2PaymentBatchStatus(): Observable<PaymentBatchStatusM2[]> {
    return this.http.get<PaymentBatchStatusM2[]>(
      this.settings.baseUrl +
        'api/PaymentSchedule/GetMilestone2PaymentBatchStatus'
    );
  }

  getMilestone2PaymentBatchActivities(
    pbName: string
  ): Observable<Milestone2PaymentBatchDetails> {
    return this.http.get<Milestone2PaymentBatchDetails>(
      this.settings.baseUrl +
        'api/PaymentSchedule/GetMilestone2PaymentBatchActivities/PaymentBatchName/' +
        pbName
    );
  }

  updateMilestone2PaymentBatch(editpb: Milestone2PaymentBatchDetails) {
    return this.http.post<ApiResponse>(
      this.settings.baseUrl +
        'api/PaymentSchedule/EditMilestone2PaymentSchedule',
      editpb
    );
  }

  ProcessPaymentCap() {
    return this.http.post<any>(
      this.settings.baseUrl + 'api/PaymentSchedule/ProcessPaymentCap',
      null
    );
  }

  sendCapLogicNotification(activityIds: number[]) {
    const headers = new HttpHeaders().set('content-type', 'application/json');
    return this.http.post<boolean>(
      this.settings.baseUrl + 'api/PaymentSchedule/SendCapLogicNotifications',
      activityIds,
      { headers }
    );
  }

  sendCsiCapLogicNotification(activityIds: number[]) {
    const headers = new HttpHeaders().set('content-type', 'application/json');
    return this.http.post<boolean>(
      this.settings.baseEventsUrl +
        'api/CSINotifications/SendCapLogicNotifications',
      activityIds,
      { headers }
    );
  }
}
